export const UPDATE_ACTIVE_SLUG = 'UPDATE_ACTIVE_SLUG';
export const UPDATE_ACTIVE_INDEX = 'UPDATE_ACTIVE_INDEX';
